import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ahaApi from "../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const doBulkCheckinCheckoutHomeHealth = createAsyncThunk(
  "homeHealth/bulkCheckinCheckoutHomeHealth",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.bulkCheckinCheckoutHomeHealth(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const bulkCheckinCheckoutHomeHealthSlice = createSlice({
  name: "bulkCheckinCheckoutHomeHealth",
  initialState,
  reducers: {
    clearBulkCheckinCheckoutHomeHealthResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doBulkCheckinCheckoutHomeHealth.pending, (state) => {
        state.loading = true;
      })
      .addCase(doBulkCheckinCheckoutHomeHealth.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(doBulkCheckinCheckoutHomeHealth.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const bulkCheckinCheckoutHomeHealthResponse = (state) => state.bulkCheckinCheckoutHomeHealthState.value;
export const bulkCheckinCheckoutHomeHealthLoading = (state) => state.bulkCheckinCheckoutHomeHealthState.loading;
export const { clearBulkCheckinCheckoutHomeHealthResponse } = bulkCheckinCheckoutHomeHealthSlice.actions;
export default bulkCheckinCheckoutHomeHealthSlice.reducer;
